import React, { useState, useEffect } from "react";
import DashboardLayout from "../../molecules/DashboardLayout";
import { Row, Col, Pagination, Card, Select, Typography, Button, Tag } from "antd";
import { getApprovalPendingReq } from "../TerminationProcess/ducks/services";
import { SectionHeaderV2 } from "../../organism/SectionHeaderV2";
import { useDispatch, useSelector } from "react-redux";
import { getMoveOuts, setMoveoutFilters } from "../Contracts/ducks/actions";
import dayjs from "dayjs";
import { formatDate, determineTerminationType } from "../../../utils/dateHelper";
import { useSearchHistory } from "../../../utils/filterHelper";
import { setFilterRenewal } from "../App/SearchFilters/ducks/actions";
import LoaderTsx from "../Loader.tsx";
import { useNavigate } from "react-router-dom";
import { formatString } from "../../../utils/formatString";
import { InfoCircleOutlined } from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import { Popup } from "../../atoms/Popup";
import { MoveOutList } from "./MoveOutList";
import { useMoveOutsSearch } from "./hooks";
import { searchByOptions as baseSearchByOptions } from "./constants/searchByOptions";
import { useFeatureToggleSearchByOptions } from "../../../hooks/search";
import { currencyFormat, statusLabel } from "../../../utils/media";
import { moveOutCol, moveOutColumn } from "./moveOutCols";
import DragAndDropList from "../../atoms/Grid/gridColumnSort";
import { getGridSettings } from "../../../utils/globalService";
import { getOrgByID } from "../../modules/Maintenance/Tickets/ducks/actions";
import { resetGridSettings } from "../../libs/constants";
import { useGridReset } from "../../../hooks/useGridReset";

const gridProps = {
  sortable: true,
  filter: true,
  resizable: true,
  minWidth: 220,
};

const moveOutDropdown = [{ id: 1, name: "Edit Move-out", status: "" }];

const searchKeys = [
  { value: "name", label: "Name" },
  { value: "unitCode", label: "Unit Code", default: true },
  { value: "property", label: "Property" },
  { value: "propertyAdmin", label: "Property Admin" },
];

const MoveOut = (props) => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [searchKey, setSearchKeys] = useState(searchKeys);
  const [isLoading, setIsLoading] = useState(false);
  const [exportData, setExportData] = useState(false);
  const [visible, setVisible] = useState(false);
  const moveoutFilters: any = useSelector((state: any) => state?.contracts?.moveoutFilters);
  const { searchHistory } = useSearchHistory(setFilterRenewal);
  const [selectedSearchBy, setSelectedSearchBy] = useState(moveoutFilters?.searchBy || "unitCode");
  const [searchValue, setSearchValue] = useState(moveoutFilters?.search ?? "");
  const [pendingApprovalsData, setpendingApprovalsData] = useState([]);
  const [approvalType, setApprovalType] = useState(null);
  const contractApi = useSelector((state: any) => state?.contracts?.contractList);
  const [moveOutColumns, setMoveOutColumns] = useState(() => [...moveOutCol(visible)]);
  const [detectColumnChanges, setDetectColumnChanges] = useState(false);
  const organization = useSelector((state: any) => state.tickets.orgData);
  const { resetGrid, setGridReset } = useGridReset();
  const { searchByOptions } = useFeatureToggleSearchByOptions(baseSearchByOptions);
  const { selectOptions, handleSearch, handleChangeSearchBy } = useMoveOutsSearch({
    selectedSearchBy,
    setSelectedSearchBy,
    setSearchValue,
  });

  const getApprovalPendingRequests = async () => {
    try {
      let data = await getApprovalPendingReq("settlementApproval=pending");
      setpendingApprovalsData(data?.data);
      setApprovalType(data?.approvalType);
    } catch (error) {
      console.log(error, "getApprovalPendingRequests");
    }
  };

  const forMoveOutFlow = [
    { label: "All", value: null },
    { label: "Awaiting Payment", value: "awaiting_payment" },
    { label: "Awaiting Refund", value: "awaiting_refund" },
    { label: "Move-out Confirmed", value: "moveout_confirmed" },
    { label: "Settlement Approved", value: "settlement_approved" },
    { label: "Settlement Confirmed", value: "settlement_confirmed" },
    { label: "Settled", value: "settled" },
  ];

  const optionsForStatus = [...forMoveOutFlow];

  const [filterOptionsForMoveOut, setFilterOptionsForMoveOut] = useState([
    {
      name: "status",
      label: "Status",
      initialValue: "All",
      title: "1",
      options: optionsForStatus,
    },
  ]);

  const [filter, setFilter] = useState(filterOptionsForMoveOut[0].initialValue);
  const [filterStatus, setStatusFilter] = useState(filterOptionsForMoveOut[0].initialValue);

  const MoreAction = (row) => {
    const { Text } = Typography;

    const onChangeHanldler = async (e) => {
      const leaseId = row?.data?.leaseId;
      navigate(`/move-out/summery/${leaseId}`, {
        state: { moveOut: true },
      });
    };

    return !visible ? (
      <Select
        onChange={onChangeHanldler}
        className="Sentence"
        placeholder="Select an action"
        style={{ width: 150 }}
        allowClear
      >
        <>
          {moveOutDropdown.map((value, key) => (
            <React.Fragment key={key}>
              <Select.Option value={value.name}>
                <Text style={{ color: `${value.status}` }}>{value.name}</Text>
              </Select.Option>
            </React.Fragment>
          ))}
        </>
      </Select>
    ) : (
      <Button type="primary" onClick={(e) => onChangeHanldler(e)}>
        View
      </Button>
    );
  };

  const setRenewalStatus = (data) => {
    return formatString(data?.moveOutStatus);
  };

  const contractsCol = (MoreAction) => [
    {
      headerName: "Approval Type",
      field: "approvalType",
      cellRendererFramework: ({ data }) => {
        return (
          <Tag className="tag-sm" color="success">
            {approvalType}
          </Tag>
        );
      },
      hide: !visible,
    },
    {
      width: 250,
      headerName: "Move-out Status",
      field: "moveOutStatus",
      cellRendererFramework: ({ data }) => {
        return (
          <Tag className="tag-sm" color="success">
            {setRenewalStatus(data)}
          </Tag>
        );
      },
    },
    {
      headerName: "Property",
      field: "propertyDetails.propertyName",
    },
    {
      headerName: "Unit Number",
      field: "propertyDetails.unitCode",
    },
    {
      headerName: "Tenant",
      field: "tenantDetails.tenantNameEN",
      cellStyle: { textTransform: "CAPITALIZE" },
    },
    {
      headerName: "Annual Rent",
      field: "annualRent",
      cellRendererFramework: ({ data }) => {
        return data?.bookingTerms?.annualBaseRent ? (
          <div style={{ position: "absolute", left: "20px" }}>
            {currencyFormat(data.bookingTerms?.annualBaseRent || data.bookingTerms?.renewalAmount)}
          </div>
        ) : (
          ""
        );
      },
    },
    {
      headerName: "Start Date",
      field: "leaseTerms.leaseStartDate",
      minWidth: 150,
      cellRendererFramework: ({ data }) => {
        return formatDate(visible ? data.leaseTerms.leaseStartDate : data.parentLeaseTerms.leaseStartDate);
      },
    },
    {
      sort: "asc",
      headerName: "End Date",
      field: "leaseTerms.leaseEndDate",
      minWidth: 150,
      cellRendererFramework: ({ data }) => {
        return formatDate(visible ? data.leaseTerms.leaseEndDate : data.parentLeaseTerms.leaseEndDate);
      },
    },
    {
      headerName: "Contract Type",
      field: "leaseType",
      cellRendererFramework: ({ data }) => {
        return statusLabel(data?.leaseType);
      },
    },
    { headerName: "AWB No", field: "shipmentNumber" },
    {
      headerName: "Owner Name",
      field: "ownerName",
      cellRendererFramework: ({ data }) => {
        return data?.ownerName || data?.propertyDetails?.ownerData?.name;
      },
    },
    {
      headerName: "Property Admin",
      field: "adminManager.name",
      cellRendererFramework: ({ data }) => {
        return data?.propertyAdmin || data?.propertyDetails?.propertyAdmin;
      },
    },
    {
      headerName: "Move-out Date",
      field: "Move-out Date",
      cellRendererFramework: ({ data }) => {
        return formatDate(data.vacatingDate) || "";
      },
    },
    {
      headerName: "Termination Type",
      field: "Termination Type",
      cellRendererFramework: ({ data }) => {
        if (visible) {
          return determineTerminationType(data.vacatingDate, data.leaseTerms.leaseEndDate);
        } else {
          return determineTerminationType(data.vacatingDate, data.parentLeaseTerms.leaseEndDate);
        }
      },
    },
    {
      headerName: "Actions",
      field: "m_action",
      filter: false,
      maxWidth: visible ? 150 : 200,
      cellRendererFramework: MoreAction,
      pinned: "right",
    },
  ];

  const handlePagination = (page, pageSize) => {
    setCurrentPage(page);
    setLimit(pageSize);
    const params = { renewalDate: filter, renewalStatus: filterStatus };
    setIsLoading(true);
    dispatch(getMoveOuts(pageSize, page, searchValue, selectedSearchBy, params, null, setIsLoading));
  };

  useEffect(() => {
    const buildLeaseColumnsWithKyc = (org) => {
      const kycFields = [...(org?.commercialKycForm || []), ...(org?.residentialKycForm || [])].filter(
        (field, index, self) => index === self.findIndex((f) => f.name === field.name)
      );

      const dynamicKycCols = kycFields.map((field, index) => ({
        id: 50 + index,
        headerName: field.label,
        field: `kycDetails.${field.name}`,
        checked: false,
        hide: true,
      }));

      const mergedLeaseCols = [...moveOutCol(visible), ...dynamicKycCols];
      getGridConfig(mergedLeaseCols);
      setMoveOutColumns(mergedLeaseCols);
    };

    const init = async () => {
      const isOrgEmpty = !organization || (typeof organization === "object" && Object.keys(organization).length === 0);

      if (isOrgEmpty) {
        const orgData = localStorage?.getItem("login-response");
        const orgId = orgData ? JSON.parse(orgData) : null;
        if (orgId) {
          await dispatch(getOrgByID(orgId?.orgId));
        }
      } else {
        buildLeaseColumnsWithKyc(organization);
      }
    };

    init();
  }, [organization, resetGrid]);

  const getGridConfig = async (columns) => {
    let result = await getGridSettings("moveOutContracts", columns, resetGrid);
    if (result?.length > 0) {
      setMoveOutColumns(result);
      setGridReset(false);
    }
  };

  useEffect(() => {
    if (moveoutFilters?.searchBy) {
      const setArray = searchKey.map((item) => {
        let val = null;
        if (item.value === moveoutFilters?.searchBy) {
          val = { ...item, default: true };
        } else {
          val = { ...item, default: false };
        }
        return val;
      });
      setSearchKeys(setArray);
    }
  }, [moveoutFilters, moveoutFilters?.searchBy]);

  useEffect(() => {
    if (
      moveoutFilters?.search != searchValue ||
      moveoutFilters?.searchBy != selectedSearchBy ||
      moveoutFilters?.filter != filter ||
      moveoutFilters?.filterStatus != filterStatus
    )
      dispatch(
        setMoveoutFilters({ search: searchValue, searchBy: selectedSearchBy, filter, filterStatus, currentPage })
      );
    const params = {};

    if (filterStatus) {
      params["renewalStatus"] = filterStatus;
    }
    if (filter) {
      params["renewalDate"] = filter;
    }
    if (exportData) {
      let checkedColumns = moveOutColumns
        .filter((col) => col.checked && col.headerName !== "Actions")
        .map((col) => col.headerName)
        .join(", ");
      params["columns"] = checkedColumns;
      params["exportData"] = exportData;
      params["totalCount"] = contractApi?.totalCount;
    }

    setCurrentPage(1);
    setIsLoading(true);
    dispatch(getMoveOuts(limit, 1, searchValue, selectedSearchBy, params, setExportData, setIsLoading));
  }, [searchValue, filter, filterStatus, exportData]);

  useEffect(() => {
    getApprovalPendingRequests();
    let key = Object.keys(searchHistory)[0];
    if (searchKey.length > 0)
      searchKey.map((item) => {
        if (key == item.value) item["default"] = true;
        else item["default"] = false;
        return item;
      });
  }, [searchHistory]);

  const filterData = (data = []) => {
    const dataCopy = [...data];

    if (dataCopy.length > 0) {
      for (let key in dataCopy) {
        if (dataCopy[key].leaseType === "new" && dataCopy[key].leaseStatus === "active") {
          const leaseTerms = {
            ...dataCopy[key].leaseTerms,
            ...{
              leaseStartDate: dayjs(dataCopy[key].leaseTerms.leaseEndDate).add(1, "day").toISOString(),
              leaseEndDate: dayjs(dataCopy[key].leaseTerms.leaseEndDate).add(1, "year").toISOString(),
            },
          };

          dataCopy[key]["leaseTerms"] = {
            ...dataCopy[key]["leaseTerms"],
            ...leaseTerms,
          };
        }
      }
    }

    return dataCopy;
  };

  const handleFilterChange = (days) => {
    setFilter(days.value);
    setStatusFilter(days.value);
  };

  //  for export data and send in email

  const exportAction = () => {
    setExportData(true);
  };

  const popup = [
    {
      title: (
        <Title level={3} className=" mb-0">
          Move-out Request(s)
        </Title>
      ),
      content: (
        <MoveOutList columns={contractsCol(MoreAction)} gridProps={gridProps} data={pendingApprovalsData ?? []} />
      ),
      width: 1650,
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[0].title,
    content: popup[0].content,
    width: popup[0].width,
    onCancel: () => {
      setVisible(false);
    },
  };

  return (
    <DashboardLayout load={loading}>
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <SectionHeaderV2
                noBorder={true}
                heading="Move-outs"
                propertyAdminOptions={true}
                total={contractApi?.totalCount ?? 0}
                onSearch={handleSearch}
                onChangeSearchBy={handleChangeSearchBy}
                defaultSearch={searchValue}
                searchByOptions={searchByOptions}
                selectOptions={selectOptions}
                viewOption={filterOptionsForMoveOut}
                viewOptionLabel={""}
                justifiedItems={true}
                justifyEnd={true}
                downloadAction={exportAction}
                handleView={handleFilterChange}
                headTopLeftText={
                  pendingApprovalsData?.length > 0 ? (
                    <Button danger type="text" onClick={() => setVisible(true)}>
                      <InfoCircleOutlined /> {pendingApprovalsData?.length} pending requests
                    </Button>
                  ) : null
                }
              />
            </Col>
            <Col span={23}>
              <Pagination
                className="ag-property-text-pagination"
                total={contractApi?.totalCount ?? 0}
                showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} Renewals`}
                pageSize={contractApi?.perPage ?? 50}
                defaultCurrent={1}
                current={currentPage || moveoutFilters?.currentPage}
                onChange={handlePagination}
              />
            </Col>
            <Col span={1}>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <DragAndDropList
                  columns={moveOutColumns}
                  setModifiedColumns={setMoveOutColumns}
                  changePicker={setDetectColumnChanges}
                  detectColumnChanges={detectColumnChanges}
                  screenName="moveOutContracts"
                  filterStatus={visible ? "visible" : "hidden"}
                  setGridReset={setGridReset}
                />
              </div>
            </Col>
            <Col span={24}>
              <Row gutter={[24, 24]} justify="end">
                <Col span={24}>
                  <Card bordered={false} className="ag-nospace-body">
                    {isLoading ? (
                      <LoaderTsx />
                    ) : (
                      <MoveOutList
                        columns={moveOutColumn(
                          moveOutColumns,
                          MoreAction,
                          setRenewalStatus,
                          approvalType,
                          visible,
                          determineTerminationType
                        )}
                        gridProps={gridProps}
                        data={filterData(contractApi?.data) ?? []}
                      />
                    )}
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Popup destroyOnClose={true} {...popupProps} />
    </DashboardLayout>
  );
};

export default MoveOut;
